<template>
  <div class="row">
    <div class="col-12">
      <div class="new-button-div" style="padding-bottom: 20px;">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ name: 'Pedidos' }">{{
            $t("app.modules.orders.title")
          }}</el-breadcrumb-item>
          <el-breadcrumb-item>
            {{ $t("app.modules.orders.details.title") }}
          </el-breadcrumb-item>
          <h6 style="margin-bottom: 0px" class="text-right">{{ $t("app.welcome") }}  {{ this.$store.state.user.nombre }} </h6>
        </el-breadcrumb>

        <td class="col-11"></td>
          <td class="col-2"><h7 style="margin-bottom: 0px" class="text-right">{{ this.$store.state.user.cliente.razonSocial }}  </h7></td>
        
      </div>
      <card class="card-nav-tabs" header-classes="card-header-primary">
        <h4 class="card-title text-purple" style="display: inline">
          {{ $t("app.modules.orders.details.title") }}
        </h4>
        <el-popover
          placement="bottom"
          width="300"
          trigger="click"
          ref="refOption"
        >
          <div class="row">
            <div class="col-12 options">
              <n-button
                v-if="permisosPeidoDetalle.confirmarPedido"
                @click.native="confirmOrder('refOption')"
                class="options-button"
                type="primary"
                size="sm"
              >
                {{ $t("app.modules.orders.form.confirm_order") }}
              </n-button>
              <n-button
                v-if="permisosPeidoDetalle.regresarPedido"
                @click.native="returnOrder('refOption')"
                class="options-button"
                type="primary"
                size="sm"
              >
                {{ $t("app.modules.orders.form.return_order") }}
              </n-button>
              <n-button
                v-if="permisosPeidoDetalle.declinar"
                @click.native="cancelOrder('refOption')"
                class="options-button"
                type="primary"
                size="sm"
              >
                {{ $t("app.modules.orders.form.cancel_order") }}
              </n-button>
            </div>
          </div>
          <n-button
            slot="reference"
            size="sm"
            icon
            class="button-options-table"
          >
            <i class="fa fa-ellipsis-v" style="color:black;"></i>
          </n-button>
        </el-popover>
        <div
          v-if="declinadoRechazado(item.estadoPedido)"
          class="alert alert-primary"
        >
          <span
            ><b>{{
              $t("app.modules.orders.status." + this.item.valueEstadoPedio) +
                ": "
            }}</b
            >{{ item.motivo }}</span
          >
        </div>
        <el-collapse accordion>
          <el-collapse-item name="1">
            <div class="row text-left">
              <div :class="'form-group has-label ' + sizes">
                <fg-input
                  type="text"
                  disabled
                  :label="$t('app.modules.orders.headers.order_number')"
                  v-model="item.numPedidoSAP"
                >
                </fg-input>
              </div>
              <div :class="'form-group has-label ' + sizes">
                <fg-input
                  type="text"
                  disabled
                  :label="$t('app.modules.orders.headers.business_name')"
                  v-model="item.cliente.razonSocial"
                >
                </fg-input>
              </div>
              <div :class="'form-group has-label ' + sizes">
                <fg-input
                  type="text"
                  disabled
                  :label="$t('app.modules.orders.details.vendor_assigned')"
                  v-model="item.vendedor.nombre"
                >
                </fg-input>
              </div>
              <div :class="'form-group has-label ' + sizes">
                <fg-input
                  type="text"
                  disabled
                  :label="$t('app.modules.orders.details.service_user')"
                  v-model="item.usuarioServicioCliente.nombre"
                >
                </fg-input>
              </div>
              <div :class="'form-group has-label ' + sizes">
                <fg-input
                  type="text"
                  disabled
                  :label="$t('app.modules.orders.headers.created_date')"
                  v-model="item.fechaCreacionPedido"
                >
                </fg-input>
              </div>
              <div
                :class="'form-group has-label ' + sizes"
                v-if="item.estadoPedido == constEstadoPedido.CONFIRMADO"
              >
                <fg-input
                  type="text"
                  disabled
                  :label="$t('app.modules.orders.headers.confirm_date')"
                  v-model="item.fechaConfirmacionPedido"
                >
                </fg-input>
              </div>
              <div :class="'form-group has-label ' + sizes">
                <fg-input
                  type="text"
                  disabled
                  v-model="item.trad_esta"
                  :label="$t('app.modules.orders.headers.status')"
                >
                </fg-input>
              </div>
              <div :class="'form-group has-label ' + sizes">
                <fg-input
                  type="text"
                  disabled
                  :label="$t('app.modules.orders.headers.purchase_order')"
                  v-model="item.ordenCompraStr"
                >
                </fg-input>
              </div>
              <div :class="'form-group has-label ' + sizes">
                <fg-input
                  type="text"
                  disabled
                  :label="$t('app.modules.orders.headers.user')"
                  v-model="item.contactoCliente.nombre"
                >
                </fg-input>
              </div>
              <div :class="'form-group has-label ' + sizes">
                <fg-input
                  type="text"
                  disabled
                  :label="$t('app.modules.orders.headers.delivery_address')"
                  v-model="item.destinoMercancia"
                >
                </fg-input>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </card>
      <card card-body-classes="table-full-width px-4 pb-3" no-footer-line>
        <div class="row">
          <div class="col-12">
            <h4 class="card-title text-purple">
              {{ $t("app.modules.orders.form.record") }}
            </h4>
            <el-collapse accordion>
              <el-collapse-item name="1">
                <el-table stripe style="width: 100%" :data="historialPedido">
                  <el-table-column
                    :label="$t('app.modules.orders.headers.modification_date')"
                    min-width="200"
                    sortable
                  >
                    <template slot-scope="scope">
                      {{ scope.row.fechaModificacion }}
                    </template>
                  </el-table-column>

                  <el-table-column
                    :label="$t('app.modules.orders.headers.action')"
                    min-width="200"
                    sortable
                  >
                    <template slot-scope="scope">
                      {{ getAccion(scope.row) }}
                    </template>
                  </el-table-column>

                  <el-table-column
                    :label="$t('app.modules.orders.headers.user')"
                    min-width="200"
                    sortable
                  >
                    <template slot-scope="scope">
                      {{ scope.row.usuario.nombre }}
                    </template>
                  </el-table-column>
                </el-table>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </card>
      <card card-body-classes="table-full-width px-4 pb-3" no-footer-line>
        <div class="row">
          <div class="col-12">
            <h4 class="card-title text-purple">
              {{ $t("app.modules.orders.add.selected_products") }}
            </h4>

            <el-table stripe style="width: 100%;" :data="productos">
              <el-table-column type="expand">
                <template slot-scope="{ row }">
                  <p>
                    {{ $t("app.modules.orders.headers.code") }} :
                    {{ row.codigo }}
                  </p>
                  <p>
                    {{ $t("app.modules.orders.headers.description") }} :
                    {{ row.descripcion }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column
                min-width="250"
                :label="$t('app.modules.orders.headers.product')"
              >
                <template slot-scope="{ row }">
                  {{ row.denominacion }}
                </template>
              </el-table-column>

              <el-table-column
                min-width="120"
                :label="$t('app.modules.orders.headers.price')"
              >
                <template slot-scope="{ row }">
                  {{ row.importe | currenciFormat }}
                </template>
              </el-table-column>
              <el-table-column
                min-width="120"
                :label="$t('app.modules.orders.headers.money')"
              >
                <template slot-scope="{ row }">
                  {{ row.moneda }}
                </template>
              </el-table-column>
              <el-table-column
                min-width="120"
                :label="$t('app.modules.orders.headers.unit')"
              >
                <template slot-scope="{ row }">
                  {{ row.unidad_medida }}
                </template>
              </el-table-column>

              <el-table-column
                min-width="240"
                :label="$t('app.modules.orders.headers.quantity')"
              >
                <template slot-scope="{ row }">
                  <el-input-number
                    :disabled="!permisosPeidoDetalle.modificar"
                    v-model="row.cantidad"
                    :min="1"
                  ></el-input-number>
                </template>
              </el-table-column>
              <el-table-column
                min-width="210"
                :label="$t('app.modules.orders.headers.delivery_date')"
              >
                <template slot-scope="{ row }">
                  <el-date-picker
                    :disabled="!permisosPeidoDetalle.modificar"
                    type="date"
                    placeholder="Date Picker"
                    v-model="row.fechaEntrega"
                    :clearable="false"
                  >
                  </el-date-picker>
                </template>
              </el-table-column>

              <el-table-column
                min-width="150"
                :label="$t('app.modules.orders.headers.subtotal')"
              >
                <template slot-scope="{ row }">
                  {{ row.subtotal | currenciFormat }}
                </template>
              </el-table-column>

              <el-table-column :label="$t('app.modules.orders.headers.quit')">
                <div slot-scope="props" class="table-actions dropdown">
                  <n-button
                    :disabled="!permisosPeidoDetalle.modificar"
                    @click.native="removeProduct(props.$index)"
                    class="like"
                    type="danger"
                    size="sm"
                    round
                    icon
                  >
                    <i class="fa fa-trash fa-2x"></i>
                  </n-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </card>

      <card
        v-if="permisosPeidoDetalle.modificar"
        card-body-classes="table-full-width px-4 pb-3"
        no-footer-line
      >
        <el-table stripe style="width: 100%" :data="orden_data">
          <el-table-column
            label="Orden de compra actual"
            min-width="300"
            sortable
          >
            <template slot-scope="scope">
              {{ scope.row.link }}
            </template>
          </el-table-column>
          <el-table-column>
            <div slot-scope="props" class="table-actions dropdown">
              <n-button
                @click.native="eliminar_orden(props.$index)"
                :disabled="!permisosPeidoDetalle.modificar"
                class="like"
                type="danger"
                size="sm"
                round
                icon
              >
                <i class="fa fa-trash fa-2x"></i>
              </n-button>
            </div>
          </el-table-column>
        </el-table>
        <div class="row form-group">
          <label for="" class="col-form-label col-12">Orden de compra</label>
          <div class="col-4">
            <input
              :disabled="!permisosPeidoDetalle.modificar"
              class="form-control mb-2"
              type="text"
              v-model="item.ordenCompraStr"
            />
          </div>
          <div class="col-12">
            <file-input
              :input-props="{ accept: 'application/pdf' }"
              v-model="files"
              :disabled="!permisosPeidoDetalle.modificar"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-12 text-center">
            <button
              type="button"
              class="btn btn-primary btn-lg"
              @click="onClickSave"
            >
              {{ $t("app.modules.orders.form.save") }}
            </button>
          </div>
        </div>
      </card>
    </div>
    <devolver-pedido-modal />
    <confirmar-pedido-modal />
  </div>
</template>
<script>
import { array_set_value, getResponse } from "@/util/utilities";
import { Direccion } from "@/models/pedidos/Direccion";
import FileInput from "@/components/Inputs/FileInput";
import OrderItemInformationEdit from "@/models/pedidos/OrderItemEdit";
import ConstEstadoPedido from "@/models/pedidos/ConstEstadoPedido";
import DevolverPedidoModal from "./devolverPedidoModal";
import ConfirmarPedidoModal from "./confirmarPedidoModal";
import { mapState } from "vuex";
export default {
  components: { DevolverPedidoModal, FileInput, ConfirmarPedidoModal },
  data() {
    return {
      permisosPeidoDetalle: {
        declinar: false,
        regresarPedido: false,
        confirmarPedido: false,
        modificar: false
      },
      paramPedidoUpdateBunch: {
        idPedido: 0,
        idCliente: 0,
        productosSeleccionados: [],
        direccionEntregaId: 0,
        fechaEntrega: "",
        tipoPedido: 0,
        ordenCompraStr: "",
        contactoCliente: 0,
        deleteOrdenCompraFile: false,
        orden: ""
      },
      orden_data: [],
      historialPedido: [],
      files: [],
      productos: [],
      pedido: [],
      sizes: "col-lg-4 col-md-4 col-sm-6",
      idPedido: 0,
      item: {
        trad_esta: "",
        cliente: {},
        contactoCliente: {},
        usuarioServicioCliente: {},
        vendedor: {},
        productoCliente: {}
      },
      constEstadoPedido: new ConstEstadoPedido()
    };
  },
  mounted() {
    EventBus.$on("reload-items", () => {
      this.$router.push({
        name: "Pedidos"
      });
    });
  },
  watch: {
    files(value) {
      this.paramPedidoUpdateBunch.orden = value[0];
    }
  },
  filters: {
    currenciFormat(value) {
      if (value) {
        let val = (value / 1).toFixed(2).replace(",", ".");
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return null;
    }
  },
  computed: {
    ...mapState(["modules"])
  },
  created() {
    // console.log(Object.entries(this.$route.params).length);
    if (Object.entries(this.$route.params).length == 0) {
      //No hay datos redireccionarlo
    } else {
      this.idPedido = this.$route.params.idPedido;
      this.initPedidoDet();
    }
  },
  methods: {
    declinadoRechazado(estatus) {
      var returnBool = false;
      if (
        estatus == this.constEstadoPedido.DEVUELTO_VALIDACION ||
        estatus == this.constEstadoPedido.DECLINADO
      ) {
        returnBool = true;
      }
      return returnBool;
    },
    returnOrder(ref) {
      this.$refs[ref].doClose();
      EventBus.$emit("devolverPedido", { idPedido: this.idPedido });
    },
    cancelOrder(ref) {
      this.$refs[ref].doClose();
      EventBus.$emit("declinarPedido", { idPedido: this.idPedido });
    },
    confirmOrder(ref) {
      this.$refs[ref].doClose();
      EventBus.$emit("confirmarPedido", { idPedido: this.idPedido });
    },
    async revisarPermisos() {
      var permisos = [];
      for (var i = 0; i < this.modules.length; i++) {
        if (this.modules[i].nombreModulo === "Pedidos-detalle") {
          permisos = this.modules[i].claimsModule;
          break;
        }
      }
      for (var con = 0; con < permisos.length; con++) {
        console.log(permisos[con].active);
        if (permisos[con].permiso == "Declinar" && permisos[con].active) {
          if (this.item.estadoPedido == this.constEstadoPedido.SINCOFIRMAR) {
            this.permisosPeidoDetalle.declinar = true;
          }
        }
        if (
          permisos[con].permiso == "Regresar Pedido" &&
          permisos[con].active
        ) {
          if (
            this.item.estadoPedido == this.constEstadoPedido.SINCOFIRMAR &&
            permisos[con].active
          ) {
            this.permisosPeidoDetalle.regresarPedido = true;
          }
        }
        if (permisos[con].permiso == "Modificar") {
          if (
            (this.item.estadoPedido == this.constEstadoPedido.SINCOFIRMAR ||
              this.item.estadoPedido ==
                this.constEstadoPedido.DEVUELTO_VALIDACION) &&
            permisos[con].active
          ) {
            this.permisosPeidoDetalle.modificar = true;
          }
        }
        if (
          permisos[con].permiso == "Confirmar Pedido" &&
          permisos[con].active
        ) {
          if (this.item.estadoPedido == this.constEstadoPedido.SINCOFIRMAR) {
            this.permisosPeidoDetalle.confirmarPedido = true;
          }
        }
      }
      console.log(permisos);
      console.log(this.item);
      console.log(this.constEstadoPedido.DEVUELTO_VALIDACION);
    },
    async updateItem() {
      for (var i = 0; i < this.productos.length; i++) {
        this.paramPedidoUpdateBunch.productosSeleccionados.push({
          idDetallePedido: this.productos[i].idDetallePedido,
          quantity: this.productos[i].cantidad,
          fechaEntrega: this.productos[i].fechaEntrega
        });
      }
      this.paramPedidoUpdateBunch.idPedido = this.idPedido;
      this.paramPedidoUpdateBunch.idCliente = this.idCliente;
      this.paramPedidoUpdateBunch.ordenCompraStr = this.item.ordenCompraStr;
      this.$lock(this.$t("app.modules.orders.add.sending_data"));
      let data = new FormData();
      data.append("files", this.paramPedidoUpdateBunch.orden);
      data.append("param", JSON.stringify(this.paramPedidoUpdateBunch));
      console.log(this.paramPedidoUpdateBunch);
      console.log(data);
      try {
        let addPedidoRequest = await this.$http.post(
          route("Pedidos/ActualizarPedido"),
          data
        );
        let response = getResponse(addPedidoRequest, null);

        if (response === null) {
          throw new Error();
        }
        this.notifyMessage("success", this.$t("app.promps.save_success"));
        this.$router.push({
          name: "Pedidos"
        });
        // this.initPedidoDet();
      } catch (e) {
        this.notifyMessage(
          "danger",
          "Sucedió un error al guardar la información"
        );
      }
      this.$swal.close();
    },
    eliminar_orden(index) {
      this.$confirm("¿Deseas eliminar el adjunto?", "", {
        confirmButtonText: this.$t("app.modules.messages.alert.yes"),
        cancelButtonText: this.$t("app.modules.messages.alert.cancel"),
        //type: "warning",
        center: true
      })
        .then(async () => {
          this.paramPedidoUpdateBunch.deleteOrdenCompraFile = true;
          this.orden_data.splice(index, 1);
        })
        .catch(() => {});
    },
    removeProduct(index) {
      if (this.productos.length < 2) {
        this.notifyMessage(
          "warning",
          this.$t("app.modules.orders.details.message_empty")
        );
      } else {
        this.$confirm(
          this.$t("app.modules.orders.details.message_delete"),
          "",
          {
            confirmButtonText: this.$t("app.modules.messages.alert.yes"),
            cancelButtonText: this.$t("app.modules.messages.alert.cancel"),
            //type: "warning",
            center: true
          }
        )
          .then(async () => {
            this.productos.splice(index, 1);
          })
          .catch(() => {});
      }
    },
    onClickSave() {
      console.log(this.productos);
      try {
        if (!!!this.productos || this.productos.length === 0) {
          throw new Error(
            this.$t("app.modules.orders.errors.no_order_selected_products")
          );
        }
        this.updateItem();
      } catch (e) {
        this.notifyMessage("danger", e.message);
      }
    },
    async loadRecord() {
      let data = new FormData();
      data.append("idPedido", this.idPedido);

      let request = await this.$http.post(
        route("Pedidos/historialPedido"),
        data
      );
      let response = getResponse(request);

      // console.log(response);
      if (response != null) {
        this.historialPedido = response.pedidos;
      }
    },
    async initPedidoDet() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      await this.getPedidoDetallePrinc();
      this.$swal.close();
    },
    async getPedidoDetallePrinc() {
      this.orden_data = [];
      const params = {
        id: parseInt(this.idPedido),
        claveIdioma: this.$store.state.lang,
        usuario: this.$store.state.user.idUsuario,
        idPedido: parseInt(this.idPedido)
      };
      await this.$http.post(route("Pedidos/detallePedidoById"), params).then(
        async response => {
          if (response.body.code === 200) {
            await this.loadRecord();
            console.log(response.body.code);
            this.item = response.body.pedido;
            //Revisar permisos
            this.revisarPermisos();
            this.item.trad_esta = this.$t(
              "app.modules.orders.status." + this.item.valueEstadoPedio
            );
            let productos = productos || [];
            productos = this.item.detalles.map(product => {
              return new OrderItemInformationEdit({
                product,
                cantidad: product.cantidad,
                denominacion: product.productoCliente.denominacion,
                importe: product.productoCliente.importe,
                fechaEntrega: product.fechaEntregaSolicitada,
                idDetallePedido: product.idDetallePedido,

                direccion: this.item.destinoMercancia,
                codigo: product.productoCliente.material,
                descripcion: product.productoCliente.denominacion,
                unidad_medida: product.productoCliente.unidadMedida,
                moneda: product.productoCliente.moneda
              });
            });
            if (this.item.ordenCompraCliente) {
              this.orden_data.push({ link: this.item.ordenCompraCliente });
            }
            this.productos = productos;
            console.log(this.productos);
          } else {
            console.log(response.body);
            // this.processError(response.body)
          }
        },
        error => {
          console.error(error);
          // this.processError(error)
        }
      );
    },
    getAccion(row) {
      if (row.accion === "I") {
        return this.$t("app.modules.orders.status.new");
      } else {
        return this.$t(
          "app.modules.orders.status." + row.estadoPedidoEntity.value
        );
        /*if(row.estadoPedidoEntity.idEstadoPedido === this.constEstadoPedido.DEVUELTO_VALIDACION){
          return this.$t("app.modules.orders.status." + row.estadoPedidoEntity.value)
            +". "
            +this.$t("app.modules.reasons_declining_order.headers.reason")
            +": "
            +row.motivo;
        }
        else {
          return this.$t("app.modules.orders.status." + row.estadoPedidoEntity.value);
        }*/
      }
    }
  }
};
</script>
<style>
.extended-forms .el-select {
  width: 100%;
  margin-bottom: 30px;
}
.card .alert {
  position: relative !important;
  width: 100%;
}

.modal-content .modal-header {
  padding-bottom: 24px;
  box-shadow: 0px 2px 5px 0px #00000021;
}

.modal-content .modal-body + .modal-footer {
  padding-top: 20px !important;
  background-color: #efefefb3;
}
</style>
